import { render, staticRenderFns } from "./IconElementHeadline.vue?vue&type=template&id=5720e31a&"
import script from "./IconElementHeadline.vue?vue&type=script&lang=js&"
export * from "./IconElementHeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5720e31a')) {
      api.createRecord('5720e31a', component.options)
    } else {
      api.reload('5720e31a', component.options)
    }
    module.hot.accept("./IconElementHeadline.vue?vue&type=template&id=5720e31a&", function () {
      api.rerender('5720e31a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconElementHeadline.vue"
export default component.exports